"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PopupTitle_1 = require("./PopupTitle");
exports.default = PopupTitle_1.default;
//# sourceMappingURL=index.js.map